<template>
  <div>
    <div style="display: inline-flex;">
      <span>
        <b-input-group size="md" prepend="デポジット残">
          <b-input class="group-label_8" :value="dispDeposit"/>
        </b-input-group>
      </span>
    </div>
    <div class="margin-left-4" style="display: inline-flex;">
      <b-button size="sm" @click="$emit('editModal')" variant="danger">新規行追加</b-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    deposit: { default: 0}
  },
  computed: {
    dispDeposit() {
      return this.formatPrice(this.deposit);
    },
  },
};
</script>

<style>
.component-top-margin-half {
  margin-top: 0.5rem;
}
.left-margin {
  padding-left: 15px;
}
.group-label_4 {
  pointer-events: none;
  width: 4rem!important;
  text-align: right;
}
.group-label_6 {
  pointer-events: none;
  width: 6rem!important;
  text-align: right;
}
.group-label_8 {
  pointer-events: none;
  width: 8rem!important;
  text-align: right;
}
</style>